import {
  ViewTransitions as NextViewTransitions,
  VIEW_TRANSITION_DEFAULT_CALLBACK,
  ViewTransitionsContext,
} from 'next-view-transitions';
import { useContext } from 'react';

export function ViewTransitions({ children }: { children: React.ReactNode }) {
  return <NextViewTransitions>{children}</NextViewTransitions>;
}

export function useIsViewTransitionsEnabled() {
  const setFinishViewTransition = useContext(ViewTransitionsContext);
  return setFinishViewTransition !== VIEW_TRANSITION_DEFAULT_CALLBACK;
}
